export default __webpack_public_path__ + "static/media/new_topbar_logo.dbe97da9.svg";